import { type MRT_ColumnDef } from "material-react-table";
import React, { useMemo } from "react";
import Loader from "../../common/Loader";
import { useOrgCohortTeamUserDetailsSA } from "../../../../tanstackQuery/queries/superAdmin/team";
import { useKeycloak } from "@react-keycloak/web";
import { Typography, useTheme } from "@mui/material";
import { ActionCell } from "./ActionCell";
import { AdminGlobalTable } from "../../../tables/AdminGlobalTable";
import { AdminTableTopToolbar } from "../../common/AdminTableTopToolbar";
import RoleDropdown from "../../common/RoleDropwdown";

export type TTeamUser = {
  userID: string;
  name: string;
  created: string;
  modified: string;
  email: string;
  phone: string | null;
  modifiedPassword: string;
  username: string;
  photoURL: string;
  website: string | null;
  authCode: string | null;
  stripeCustomerID: string;
  failedLoginAttempts: number;
  activeOrgID: string;
  activeGroupID: string;
  announcementID: string;
  showInStats: number;
  createdF: string;
  oryStatus: number;
  foreignAuthKey: string | null;
  defaultOrgID: string;
  defaultGroupID: string;
  roleID: string;
  roleName: string;
};


const TeamUserTable = ({ teamUserDetailsParam }) => {
  const theme = useTheme();
  const columns = useMemo<MRT_ColumnDef<TTeamUser>[]>(
    () => [
      {
        accessorKey: "name",
        header: "Name",
        // size: 120,
        Cell: (cell) => {
          return (
            <Typography fontSize="15px">{cell.row.original.name}</Typography>
          );
        }
      },
      {
        accessorKey: "email",
        header: "Email",
        // size: 120,
        Cell: (cell) => {
          return (
            <Typography fontSize="15px">{cell.row.original.email}</Typography>
          );
        }
      },
      {
        accessorKey: "username",
        header: "Username",
        // size: 120,
        Cell: (cell) => {
          return (
            <Typography fontSize="15px">
              {cell.row.original.username}
            </Typography>
          );
        }
      },
      {
        accessorKey: "roleName",
        header: "Role",
        // size: 120,
        Cell: (cell) => {
          const roleData={
            ...cell?.row?.original,
            groupID:teamUserDetailsParam?.teamID,
            groupType:"Team"
          }
          return <RoleDropdown roleInfo={roleData}  />
        }
      },
      {
        header: "Action",
        // size: 120,
        Cell: ActionCell
      }
    ],
    []
  );

  const { keycloak } = useKeycloak();
  const { data: userData, isLoading: isUserLoading } =
    useOrgCohortTeamUserDetailsSA(
      { accessToken: keycloak?.token },
      {
        teamID: teamUserDetailsParam.teamID
      },
      {
        enabled: !!(keycloak?.token && teamUserDetailsParam.teamID)
      }
    );

  if (isUserLoading) {
    return <Loader />;
  }
  return (
    <>
      <AdminGlobalTable
        columns={columns}
        data={userData}
        config={{
          enableSelectAll: true,
          // enableRowSelection: true,
          // muiSelectCheckboxProps: { 
          //   color: "secondary",
          //   sx:{ 
          //     '& input[type="checkbox"]': {
          //     height: '44px !important',
          //   },}
          //  },
          muiTableContainerProps: {
            sx: {
              maxHeight: "calc(100vh - 505px)",
              minHeight: "calc(100vh - 505px)"
            }
          },
          muiTableBodyRowProps: () => ({
            hover: false,
            sx: {
              backgroundColor: "transparent",
              ":hover": { backgroundColor: theme?.custom?.hoverOptionColor }
            }
          }),
          renderTopToolbarCustomActions: ({ table }) => (
            <AdminTableTopToolbar
              title="Team Users List"
              table={table}
              data={userData}
            />
          )
        }}
      />
    </>
  );
};

export default TeamUserTable;
